// extracted by mini-css-extract-plugin
export default {"contactMe":"ContactMe_contactMe__s6uGR","social":"ContactMe_social__IjNNQ"};